export default "__VITE_ASSET__DpXRt6qn__"